import React from 'react';
import { useTranslation } from 'react-i18next';

import AboutUsBG from '../../assets/AboutUsBG.jpg';
import { ContentBox } from '../../components/ContentBox';
import { Navbar } from '../../components/Navbar';
import { ContactUsButton } from '../../components/buttons/ContactUsButton';

const AboutUsPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Navbar
        src={AboutUsBG}
        pageName={t('aboutUsPage.navbar.pageName')}
        pageText={t('aboutUsPage.navbar.pageText')}
      />
      {/* ── THE TEAM ──────────────────────────────────── */}
      <ContentBox
        title={t('aboutUsPage.team.title')}
        content={
          <div className="space-y-4">
            <p className="text-base leading-8">{t('aboutUsPage.team.intro')}</p>
            <ul className="space-y-3 pl-4">
              {t('aboutUsPage.team.members', { returnObjects: true }).map(
                ({ name, organization, url }) => (
                  <li key={name} className="text-base text-gray-700">
                    <span className="font-medium text-SLIGreen">{name}</span>
                    {url ? (
                      <>
                        {' — '}
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-SLIGreen hover:underline"
                        >
                          {organization}
                        </a>
                      </>
                    ) : (
                      <span className="text-gray-500"> — {organization}</span>
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
        }
        bgColor={'#CFE3F6'}
        titleColor={'#2E7A32'}
        textAlign={'text-left'}
      />
      {/* ── GET INVOLVED ──────────────────────────────── */}
      <ContentBox
        title={t('aboutUsPage.support.title')}
        content={
          <div className="flex flex-col md:flex-row md:items-center gap-8">
            <div className="flex-1">
              <p className="text-base leading-8">{t('aboutUsPage.support.paragraph1')}</p>
            </div>
            <div className="flex-shrink-0">
              <ContactUsButton>{t('aboutUsPage.support.contactButton')}</ContactUsButton>
            </div>
          </div>
        }
        bgColor={'#FAF8F4'}
        titleColor={'#2E7A32'}
        textAlign={'text-left'}
      />
    </div>
  );
};

export { AboutUsPage };
